import React, { useEffect, useState } from "react";
import AppRoutes from "./routes";
import Toast from "./components/toastMessage/Toast";
import GlobalContext from "./components/Context/GlobalContext";
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from "./store";
import { fetchFeatureFlags } from "./functions/appconfig";
import { useDispatch } from "react-redux";
import { setFeatureFlags } from "./store/slices/featureFlags";
import awsconfig from "./config/awsconfig";
import { AwsRum, type AwsRumConfig } from 'aws-rum-web';

if (import.meta.env.VITE_STAGE === 'prod') {
  console.log("awsconfig.stage", awsconfig.Auth.Cognito.stage);

try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1 ,
    identityPoolId: "me-central-1:6bd4e155-4914-4118-9cb0-6b74b4cb22e5" ,
    endpoint: "https://dataplane.rum.me-central-1.amazonaws.com" ,
    telemetries: ["performance","errors","http"] ,
    allowCookies: true ,
    enableXRay: false ,
    signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
  };

  const APPLICATION_ID: string = 'f2371b4d-5842-4924-b715-5b89e76fc7a8';
  const APPLICATION_VERSION: string = '1.0.0';
  const APPLICATION_REGION: string = 'me-central-1';

  const awsRum: AwsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}}


const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    // Define an asynchronous function to fetch feature flags
    const fetchFlags = async () => {
      try {
        // Fetch the feature flags from the API or service
        const flags = await fetchFeatureFlags();
  
        // Dispatch the fetched flags to update the state using Redux
        dispatch(setFeatureFlags(flags));
      } catch (error) {
        // Log an error if fetching feature flags fails
        console.error("Error fetching feature flags:", error);
      }
    };
  
    // Call the fetchFlags function when the component mounts
    fetchFlags();
  }, []); // Empty dependency array ensures this effect runs only once on mount
  return (
    <PersistGate loading={null} persistor={persistor}>
      <div className="min-h-screen bg-gray-100 overflow-hidden">
        <GlobalContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
          <AppRoutes />
          <Toast />
        </GlobalContext.Provider>
      </div>
    </PersistGate >
  );
};

export default App;
